export const breadcrumbs = [
  // {
  //   link: "dashboard",
  //   breadcrumb: [{ title: "首页" }],
  // },
  {
    link: "dashboard",
    breadcrumb: [{ title: "数据看板" }],
  },
  {
    link: "videoPublish?type=video",
    breadcrumb: [
      { title: "首页", path: "dashboard" },
      { title: "内容管理" },
      { title: "视频发布", path: "videoPublish?type=video" },
      { title: "列表" },
    ],
  },

  {
    link: "videoPublish?type=draft",
    breadcrumb: [
      { title: "首页", path: "dashboard" },
      { title: "内容管理" },
      { title: "视频发布", path: "videoPublish?type=video" },
      { title: "草稿" },
    ],
  },

  {
    link: "videoPublishDetail?id",
    breadcrumb: [
      { title: "首页", path: "dashboard" },
      { title: "内容管理" },
      { title: "视频发布", path: "videoPublish?type=video" },
      { title: "详情" },
    ],
  },

  {
    link: "videoPublishDetail",
    breadcrumb: [
      { title: "首页", path: "dashboard" },
      { title: "内容管理" },
      { title: "视频发布", path: "videoPublish?type=video" },
      { title: "创建" },
    ],
  },

  {
    link: "articlePublish?type=first",
    breadcrumb: [
      { title: "首页", path: "dashboard" },
      { title: "内容管理" },
      { title: "文章发布", path: "articlePublish?type=article" },
      { title: "初编池" },
    ],
  },
  {
    link: "articlePublish?type=draft",
    breadcrumb: [
      { title: "首页", path: "dashboard" },
      { title: "内容管理" },
      { title: "文章发布", path: "articlePublish?type=article" },
      { title: "草稿" },
    ],
  },

  {
    link: "articlePublish",
    breadcrumb: [
      { title: "首页", path: "dashboard" },
      { title: "内容管理" },
      { title: "文章发布", path: "articlePublish?type=article" },
      { title: "列表" },
    ],
  },

  {
    link: "articleDetail?id",
    breadcrumb: [
      { title: "首页", path: "dashboard" },
      { title: "内容管理" },
      { title: "文章发布", path: "articlePublish?type=article" },
      { title: "详情" },
    ],
  },
  {
    link: "articleDetail",
    breadcrumb: [
      { title: "首页", path: "dashboard" },
      { title: "内容管理" },
      { title: "文章发布", path: "articlePublish?type=article" },
      { title: "创建" },
    ],
  },
  /* 问卷管理 列表 */
  {
    link: "questionManage?type=list",
    breadcrumb: [
      { title: "首页", path: "dashboard" },
      { title: "答题管理" },
      { title: "问卷管理" },
      { title: "问卷列表" },
    ],
  },
  /* 问卷管理 回收站 */
  {
    link: "questionManage?type=recycle",
    breadcrumb: [
      { title: "首页", path: "dashboard" },
      { title: "答题管理" },
      { title: "问卷管理" },
      { title: "回收站" },
    ],
  },
  /* 新建 编辑 */
  {
    link: "questionAdd?id",
    breadcrumb: [
      { title: "首页", path: "dashboard" },
      { title: "答题管理", path: "questionManage" },
      { title: "编辑" },
    ],
  },
  {
    link: "questionAdd",
    breadcrumb: [
      { title: "首页", path: "dashboard" },
      { title: "答题管理", path: "questionManage" },
      { title: "新建" },
    ],
  },

  /* 成绩数据 */
  {
    link: "performance",
    breadcrumb: [
      { title: "首页", path: "dashboard" },
      { title: "答题管理", path: "questionManage" },
      { title: "成绩数据" },
    ],
  },
  /* 题目 */
  {
    link: "questionTopic",
    breadcrumb: [
      { title: "首页", path: "dashboard" },
      { title: "答题管理", path: "questionManage" },
      { title: "题目" },
    ],
  },
  /* 题库管理 */
  {
    link: "questionBankAdd",
    breadcrumb: [
      { title: "首页", path: "dashboard" },
      { title: "答题管理" },
      { title: "题库管理" },
      { title: "题目" },
    ],
  },
  //题库
  {
    link: "questionBank?type=list",
    breadcrumb: [
      { title: "首页", path: "dashboard" },
      { title: "答题管理" },
      { title: "题库管理" },
    ],
  },
  {
    link: "questionBank?type=recycle",
    breadcrumb: [
      { title: "首页", path: "dashboard" },
      { title: "答题管理" },
      { title: "题库管理" },
      { title: "回收站" },
    ],
  },
  {
    link: "groupContent?id",
    breadcrumb: [
      { title: "首页", path: "dashboard" },
      { title: "媒体号管理" },
      { title: "圈子管理", path: "group" },
      { title: "内容管理" },
    ],
  },
  {
    link: "group",
    breadcrumb: [
      { title: "首页", path: "dashboard" },
      { title: "媒体号管理" },
      { title: "圈子管理" },
    ],
  },

  {
    link: "redPacketHistory",
    breadcrumb: [
      { title: "首页", path: "dashboard" },
      { title: "红包领取记录" },
    ],
  },

  {
    link: "shops",
    breadcrumb: [{ title: "首页", path: "dashboard" }, { title: "门店管理" }],
  },

  {
    link: "questionAttends?id",
    breadcrumb: [
      { title: "首页", path: "dashboard" },
      { title: "问答管理", path: "question" },
      { title: "参与列表" },
    ],
  },

  {
    link: "question",
    breadcrumb: [{ title: "首页", path: "dashboard" }, { title: "问答管理" }],
  },

  {
    link: "userAvatar",
    breadcrumb: [{ title: "首页", path: "dashboard" }, { title: "修改头像" }],
  },

  {
    link: "userPassword",
    breadcrumb: [{ title: "首页", path: "dashboard" }, { title: "修改密码" }],
  },

  {
    link: "userPhoneNumber",
    breadcrumb: [{ title: "首页", path: "dashboard" }, { title: "修改手机号" }],
  },

  {
    link: "couponsReceive?id",
    breadcrumb: [
      { title: "首页", path: "dashboard" },
      { title: "优惠券管理", path: "coupons" },
      { title: "领用列表" },
    ],
  },

  {
    link: "thirdPartyCoupons?id",
    breadcrumb: [
      { title: "首页", path: "dashboard" },
      { title: "优惠券管理", path: "coupons" },
      { title: "第三方券码" },
    ],
  },

  {
    link: "couponDetail?id",
    breadcrumb: [
      { title: "首页", path: "dashboard" },
      { title: "优惠券管理", path: "coupons" },
      { title: "详情" },
    ],
  },

  {
    link: "couponDetail",
    breadcrumb: [
      { title: "首页", path: "dashboard" },
      { title: "优惠券管理", path: "coupons" },
      { title: "创建" },
    ],
  },

  {
    link: "coupons",
    breadcrumb: [{ title: "首页", path: "dashboard" }, { title: "优惠券管理" }],
  },

  {
    link: "couponWriteOff",
    breadcrumb: [{ title: "首页", path: "dashboard" }, { title: "核销列表" }],
  },

  {
    link: "operator",
    breadcrumb: [
      { title: "首页", path: "dashboard" },
      { title: "媒体号管理" },
      { title: "运营人员管理" },
    ],
  },
  {
    link: "createOperator",
    breadcrumb: [
      { title: "首页", path: "dashboard" },
      { title: "媒体号管理" },
      { title: "运营人员管理", goBack: 1 },
      { title: "新建" },
    ],
  },
  {
    link: "mediaRoleDetail",
    breadcrumb: [
      { title: "首页", path: "dashboard" },
      { title: "媒体号管理" },
      { title: "角色管理", path: "mediaRole" },
      { title: "新建" },
    ],
  },
  {
    link: "mediaRole",
    breadcrumb: [
      { title: "首页", path: "dashboard" },
      { title: "媒体号管理" },
      { title: "角色管理" },
    ],
  },
  {
    link: "media",
    breadcrumb: [
      { title: "首页", path: "dashboard" },
      { title: "媒体号管理" },
      { title: "媒体号管理" },
    ],
  },
  {
    link: "userInfo",
    breadcrumb: [
      { title: "首页", path: "dashboard" },
      { title: "媒体号管理" },
      { title: "用户中心" },
    ],
  },

  {
    link: "circleReview",
    breadcrumb: [
      { title: "首页", path: "dashboard" },
      { title: "媒体号管理" },
      { title: "圈子评论管理" },
    ],
  },
  {
    link: "articleComments?id",
    breadcrumb: [{ title: "首页", path: "dashboard" }, { title: "文章评论" }],
  },

  {
    link: "videoComments?id",
    breadcrumb: [{ title: "首页", path: "dashboard" }, { title: "视频评论" }],
  },
  {
    link: "topicManage",
    breadcrumb: [{ title: "首页", path: "dashboard" }, { title: "话题管理" }],
  },

  {
    link: "topicContent",
    breadcrumb: [
      { title: "首页", path: "dashboard" },
      { title: "话题管理", path: "topicManage" },
      { title: "内容管理" },
    ],
  },
  {
    link: "topicComment",
    breadcrumb: [
      { title: "首页", path: "dashboard" },
      { title: "话题管理", path: "topicManage" },
      { title: "内容管理", goBack: 1 },
      { title: "回复" },
    ],
  },
];
